module.exports = __webpack_public_path__ + "static/media/Halloween_RewardBackground.0ad11048.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/reward-background/Halloween_RewardBackground.png
// module id = 1360
// module chunks = 3